import * as $ from "jquery";
import {MapEvent} from "./Types";
import {Format} from "./Format";
import {MapView} from "./MapView";

/**
 * Списак термина за изабрани филтер.
 * За један дан групише се по општини, а за више дана по датуму
 * (тада је датум важнији, па иду „14.9.", па општине тог дана, затим „15.9." итд).
 */
export class ListPanel {

    public static render(events: MapEvent[]): void {
        const body = $('#listBody').empty();
        $('#listCount').text(events.length);
        if (events.length === 0) {
            body.append('<div class="list-group-item text-muted">Нема термина за изабрани дан.</div>');
            return;
        }
        const multiDay = MapView.mapOptions.time === 'THIS_WEEK' || MapView.mapOptions.time === 'PLANNED';
        const groups: Record<string, MapEvent[]> = {};
        const order: string[] = [];
        events.forEach(ev => {
            const key = multiDay
                ? Format.dayLabel(new Date(ev.eventTime))
                : (ev.pointMunicipality || ev.place || 'Остало');
            if (!groups[key]) {
                groups[key] = [];
                order.push(key);
            }
            groups[key].push(ev);
        });
        // по датуму: редослед је хронолошки (термини већ стижу сортирани); по општини: азбучно
        const keys = multiDay ? order : order.slice().sort((a, b) => a.localeCompare(b, 'sr'));
        keys.forEach(key => {
            body.append($('<div class="list-group-item group-head"></div>').text(key));
            groups[key]
                .sort((a, b) => multiDay
                    ? (a.pointMunicipality || a.place || '').localeCompare(b.pointMunicipality || b.place || '', 'sr')
                    : new Date(a.eventTime).getTime() - new Date(b.eventTime).getTime())
                .forEach(ev => {
                    const item = $('<a class="list-group-item list-group-item-action"></a>');
                    if (multiDay) {
                        item.append($('<div class="fw-semibold"></div>')
                                .text(ev.pointMunicipality || ev.place || ev.title));
                        item.append($('<div class="small"></div>').text(Format.placeLine(ev)));
                        item.append($('<div class="small text-muted"></div>').text(Format.timeRange(ev)));
                    } else {
                        item.append($('<div class="fw-semibold"></div>').text(ev.title));
                        item.append($('<div class="small"></div>').text(Format.placeLine(ev)));
                        item.append($('<div class="small text-muted"></div>').text(Format.schedule(ev)));
                    }
                    item.on('click', () => {
                        MapView.focus(ev.latitude, ev.longitude);
                        MapView.showEvent(ev);
                    });
                    body.append(item);
                });
        });
    }

    public static setTitle(title: string): void {
        $('#listTitle').text(title);
    }
}
